<a
  *ngIf="!externalPath"
  class="back-link"
  [ngClass]="backLinkClass"
  [routerLink]="path"
  [queryParams]="queryParams"
  [attr.aria-label]="ariaLabel"
>
  <vtmn-play-icon
    [name]="backLinkIcon"
    class="back-link__icon"
  ></vtmn-play-icon>
</a>

<a
  *ngIf="externalPath"
  class="back-link"
  [href]="externalPath"
  [attr.aria-label]="ariaLabel"
>
  <vtmn-play-icon
    class="back-link__icon"
    [ngClass]="backLinkClass"
    [name]="backLinkIcon"
  ></vtmn-play-icon>
</a>
